// Ticket enums with Persian translations

// Ticket Category enum (starts from 0)
export const TicketCategory = {
  MatchDispute: 0,
  PaymentIssue: 1,
  BugReport: 2,
  GeneralQuestion: 3,
};

// Ticket Category Persian translations
export const TicketCategoryPersian = {
  [TicketCategory.MatchDispute]: 'اختلاف در مسابقه',
  [TicketCategory.PaymentIssue]: 'مشکل پرداخت',
  [TicketCategory.BugReport]: 'گزارش خطا',
  [TicketCategory.GeneralQuestion]: 'سوال عمومی',
};

// Ticket Priority enum (starts from 0)
export const TicketPriority = {
  Low: 0,
  Medium: 1,
  High: 2,
};

// Ticket Priority Persian translations
export const TicketPriorityPersian = {
  [TicketPriority.Low]: 'کم',
  [TicketPriority.Medium]: 'متوسط',
  [TicketPriority.High]: 'زیاد',
};

// Ticket Status enum (starts from 0)
export const TicketStatus = {
  Open: 0,
  InProgress: 1,
  Closed: 2,
};

// Ticket Status Persian translations
export const TicketStatusPersian = {
  [TicketStatus.Open]: 'باز',
  [TicketStatus.InProgress]: 'در حال بررسی',
  [TicketStatus.Closed]: 'بسته',
};

// Ticket Status Badge configurations
export const TicketStatusBadge = {
  [TicketStatus.Open]: { bg: 'warning', text: 'dark' },
  [TicketStatus.InProgress]: { bg: 'info', text: 'white' },
  [TicketStatus.Closed]: { bg: 'success', text: 'white' },
};

// Ticket Priority Badge configurations
export const TicketPriorityBadge = {
  [TicketPriority.Low]: { bg: 'success', text: 'white' },
  [TicketPriority.Medium]: { bg: 'warning', text: 'dark' },
  [TicketPriority.High]: { bg: 'danger', text: 'white' },
};
